import React from 'react';
import {PlayersDashboard as BasePlayersDashboard} from 'desktop/sports/golf/players-dashboard/tiers';

class PlayersDashboard extends BasePlayersDashboard {}

export {PlayersDashboard};
